module.exports = __webpack_public_path__ + "03_bob_gold.5877293b.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/daughter/layer5/03_bob_gold.png
// module id = Z7sI
// module chunks = 0